import React, { useState } from 'react'
import {
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import LoadingLive from './LoadingLive'
import Live from './Live'
import NoLive from './NoLive'
import { getStreamResource } from '../../services/api/streaming'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { liveVideoId } from '../../config/live'

const LiveVideo = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const [live, setLive] = useState(false)
  const [xhr, setXhr] = useState('pending')

  useIonViewDidEnter(() => {
    setXhr('pending')
    setLive(false)
    setIsVisible(true)
    setRootMetaTags()
    setView(window.location.pathname)
    setPixelView()
    getLive()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  const getLive = () => {
    const params = {
      stream_id: liveVideoId
    }
    getStreamResource(params)
      .then((response) => {
        if (response[0].status === 'on-line') {
          setLive(response[0])
          setXhr('accepted')
          setRootMetaTags({
            title: response[0].public_name
          })
        } else {
          setLive(false)
          setXhr('rejected')
        }
      })
      .catch(() => {
        setLive(false)
        setXhr('rejected')
      })
  }

  if (isVisible === false) return null

  if (xhr === 'pending') {
    return <LoadingLive />
  } else if (xhr === 'accepted') {
    return <Live resource={live} />
  } else if (xhr === 'rejected') {
    return <NoLive />
  }
}

export default LiveVideo
